import React, { useMemo } from 'react';
import { ColumnDef, TableMeta } from '@tanstack/react-table';
import { Input } from '@/components/uiKit/FormControl';

interface CustomTableMeta extends TableMeta<any> {
  updateData: (rowIndex: number, columnId: string, value: any) => void;
}

type UpdateDataValue = boolean | string;

interface UpdateDataArgs {
  rowIndex: number;
  columnId: string;
  value: UpdateDataValue;
  table: any;
}

const updateTableCellData = ({ rowIndex, columnId, value, table }: UpdateDataArgs): void => {
  const meta = table.options.meta as CustomTableMeta;
  meta?.updateData(rowIndex, columnId, value);
};

export const useBeltMisalignmentTable = () => {
  const columns: ColumnDef<any>[] = useMemo(() => {
    return [
      {
        accessorKey: 'asset_ui_name',
        header: 'Site Name & Asset Name',
        cell: ({ row }) => {
          const { site_name, asset_ui_name } = row.original;

          return (
            <div>
              <div>{asset_ui_name}</div>
              <div className="text-sm text-gray-500">{site_name}</div>
            </div>
          );
        },
        enableFiltering: false,
      },
      {
        accessorKey: 'time_to_alarm',
        header: 'Time To Alarm',
        cell: ({ row, column, table }) => {
          const value = row.original.parameters.find((param: any) => param.name === 'time_to_alarm')?.value;

          const handleChange = (event: any) => {
            const value = event.target.value;
            updateTableCellData({
              rowIndex: row.index,
              columnId: column.id,
              value,
              table,
            });
          };
          return <Input type="number" variant="outlined" value={value} onChange={handleChange} />;
        },
      },
      {
        accessorKey: 'drift_allowance',
        header: 'Drift Allowance',
        cell: ({ row, column, table }) => {
          const value = row.original.parameters.find((param: any) => param.name === 'drift_allowance')?.value;

          const handleChange = (event: any) => {
            const value = event.target.value;
            updateTableCellData({
              rowIndex: row.index,
              columnId: column.id,
              value,
              table,
            });
          };
          return <Input type="number" variant="outlined" value={value} onChange={handleChange} />;
        },
      },
      {
        accessorKey: 'events_to_alarm',
        header: 'Events To Alarm',
        cell: ({ row, column, table }) => {
          const value = row.original.parameters.find((param: any) => param.name === 'events_to_alarm')?.value;

          const handleChange = (event: any) => {
            const value = event.target.value;
            updateTableCellData({
              rowIndex: row.index,
              columnId: column.id,
              value,
              table,
            });
          };
          return <Input type="number" variant="outlined" value={value} onChange={handleChange} />;
        },
      },
    ];
  }, []);

  return {
    columns,
  };
};
